import {useApiSuspenseQuery} from 'src/hooks/useApiQuery';
import type {LandingDashboardResponse} from 'src/types/byod';
import {BYOD_API_BASE as BASE} from 'src/components/analytics-genesis/byod/api';
import {byodQueryDefaults} from 'src/components/analytics-genesis/byod/api/error-handling';

// GET /analytics/byod/dashboards?is_landing=true — the agency's pinned
// (landing-page) dashboard. Returns {dashboard: null} when none is set.
// Suspense query: loading suspends, errors throw to the nearest error boundary.
export function useLandingDashboard() {
  return useApiSuspenseQuery<LandingDashboardResponse>(
    {
      pathname: `${BASE}/dashboards`,
      query: {is_landing: 'true'},
    },
    {
      queryOptions: {
        ...byodQueryDefaults,
        queryKey: ['byod-landing-dashboard'],
        staleTime: 30 * 1000,
        gcTime: 60 * 1000,
      },
    },
  );
}
